module.exports = __webpack_public_path__ + "static/media/AcadiaConnect_Service_Request_Digital_27AUG20.bab7af4c.pdf";